export default __webpack_public_path__ + "static/media/linkStatus.4fec4ee6.svg";